<script lang="ts" setup>
export interface PagesFaqMenuItemProps {
    to: VNuxtLinkTo
    text: string
    label?: string
}

const props = defineProps<PagesFaqMenuItemProps>()
</script>
<template>
  <li class="mb-4">
    <VNuxtLink
      :to="props.to"
      :label="props.label"
    >
      {{ props.text }}
    </VNuxtLink>
  </li>
</template>
